'use strict';

var React = require('react');
require('../../../theme/breakpoints.js');
var useIMask = require('../../../hooks/useIMask.js');
require('resize-observer-polyfill');

const useCustomFormatMask = ({ format, inputRef, onChange, parse, value, acceptChar = () => true, }) => {
    const commit = React.useCallback((nextValue, masked) => {
        masked._value = format(parse(nextValue));
    }, [parse, format]);
    const prepare = React.useCallback((str) => (acceptChar(str) ? str : ''), [acceptChar]);
    const maskRef = useIMask.useIMaskInstance({
        inputRef,
        options: React.useMemo(() => ({ mask: /^.+$/, prepare, commit }), [prepare, commit]),
    });
    useIMask.useIMaskAcceptListener(maskRef, React.useCallback(event => onChange(parse(maskRef.current?.value ?? ''), event), [onChange, parse]));
    React.useEffect(() => {
        const mask = maskRef.current;
        const next = parse(value ?? '');
        const current = parse(mask?.value ?? '');
        if (mask && next !== current) {
            mask.value = format(next);
        }
    }, [value, parse, format]);
};

exports.useCustomFormatMask = useCustomFormatMask;
//# sourceMappingURL=useCustomFormatMask.js.map
